import axios from "axios";
import { API_BASE_URL } from "../../config/api";
import { axiosAuthDefaults } from "./axiosAuthConfig";

/**
 * Login, register, 2FA verify vb. — sunucunun httpOnly oturum çerezini
 * (Set-Cookie) tarayıcıya yazabilmesi için withCredentials zorunlu.
 */
const authHttpClient = axios.create({
  baseURL: API_BASE_URL,
  ...axiosAuthDefaults,
});

export default authHttpClient;
